import { TextareaControl, TextControl } from '@/frontend/features/Fde/FormControls'
import type { FdeCopy } from '@/frontend/features/Fde/types'

interface Props {
  copy: FdeCopy
  jobTitle: string
  description: string
  agent?: boolean
  onTitleChange: (value: string) => void
  onDescriptionChange: (value: string) => void
}

export default function ParticipantProfileFields({ copy, jobTitle, description, agent, onTitleChange, onDescriptionChange }: Props) {
  return <div className="space-y-4">
    {agent ? <div><p className="text-sm font-medium">{copy.people.job_title}</p><p className="mt-1 text-sm text-muted-foreground">{jobTitle || copy.people.agent}</p></div> : <TextControl label={copy.people.job_title} value={jobTitle} maxLength={160} onChange={(event) => onTitleChange(event.target.value)} />}
    <TextareaControl label={copy.people.brief_description} value={description} rows={4} maxLength={500} onChange={(event) => onDescriptionChange(event.target.value)} />
    <p className="text-xs leading-5 text-muted-foreground">{agent ? copy.people.agent_description_hint : copy.people.description_hint}</p>
  </div>
}
